// extracted by mini-css-extract-plugin
export var hideEditor = "_ky-2";
export var infoIcon = "_ky-3";
export var label = "_ky-1";
export var labelContainer = "_ky-0";
export var readonlyText = "_ky-4";